import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getShipmentStatusReasonAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentStatusType`,
    method: 'get',
  });
};

export type ShipmentStatusReasonResponse = {
  codeId: string;
  codeDesc: string;
  value1: null;
  value2: null;
  value3: null;
  string1: null;
  string2: null;
  string3: null;
}[];

export const fetchShipmentStatusReason = async (): Promise<ShipmentStatusReasonResponse> => {
  const response: AxiosResponse<ShipmentStatusReasonResponse> = await getShipmentStatusReasonAPI();
  return response.data;
};
